<div [pTooltip]="tooltipKey() | transloco">
  <p-select
    appendTo="body"
    [options]="options()"
    [ngModel]="value()"
    (ngModelChange)="selectionChange.emit($event)"
    optionLabel="label"
    optionValue="value"
    [style]="{width: '150px'}"
    [disabled]="isReadOnly()"
  />
</div>
